
import { lceModalTypes } from './lceModalTypes';

export const lceModalConfig = [
    {
        modalType: lceModalTypes.MARRIAGE_MODAL,
        modalId: 'marriage-modal',
        modalHeaderTextData: 'lce.marriage.modal.header'
    }
];
